import { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { Search } from 'lucide-react';

type NoDataProps = {
    message: string;
    icon?: ReactNode;
};

export const NoData = ({ message, icon }: NoDataProps) => {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5, delay: 1.0 }}
            className="flex flex-col items-center justify-center text-gray-500 py-10"
        >
            <div className="flex mb-4">{icon || <Search strokeWidth={2} size={80} />}</div>
            <p className="font-notojp text-center text-sm">{message}</p>
        </motion.div>
    );
};
